import React, { Fragment } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Icon, HR, Typo } from 'tmt-ui-kit';

import withTrip from './withTrip';
import { actions as availabilityActions } from '~/redux/reducers/availability';
import { isDateStatusMatch } from '~/utils/trip';

const ReplaceableContainer = styled.div`
  font-size: 14px !important;
  box-sizing: border-box;
`;

const ReplaceableText = styled(Typo.Paragraph)`
  font-size: 13px !important;
  text-align: center;
  margin: 0;
`;

const Username = styled.span`
  font-weight: 500 !important;
`;

const AcceptSwapContainer = styled.div`
  display: flex;
  padding-left: 8px;
  padding-top: 4px;
`;

const ReplaceableInput = styled.div`
  cursor: pointer;
  float: left;
  width: 16px;
  height: 16px;
  margin: 4px 12px 0 1px;
  border: 1px solid ${props => props.theme.darkBlue};
  border-radius: 4px;
  position: relative;
`;

const CheckIcon = styled(Icon)`
  color: ${props => props.theme.blue};
  position: absolute;
  font-size: 16px;
  width: 16px;
  height: 16px;
  font-weight: bold;
`;

const AcceptText = styled(ReplaceableText)`
  text-align: left;
  max-width: 240px;
`;

const enhance = connect(
  state => ({
    availability: state.availability,
    sessionData: state.session.data,
  }), {
    toggleAcceptSwap: availabilityActions.toggleAcceptSwap,
  }
);

const SwapBlock = (props) => {
  const { availability, trip, toggleAcceptSwap, sessionData } = props;
  let { selectedDate } = availability;
  if (selectedDate.length === 0) selectedDate = sessionData.date;
  const tripAvailabilities = availability.availabilities;
  const replaceable = isDateStatusMatch('replaceable', selectedDate, tripAvailabilities);
  const username = trip.user_id ? `${trip.user_id.name.first} ${trip.user_id.name.last}` : '';
  const { acceptSwap } = availability;
  return (
    <Fragment>
      {replaceable && [
        <ReplaceableContainer key="replaceable">
          <ReplaceableText><Username>{username}</Username> is unavailable on the selected date.</ReplaceableText>
          <AcceptSwapContainer>
            <ReplaceableInput onClick={toggleAcceptSwap}>
              {acceptSwap && <CheckIcon name="check" />}
            </ReplaceableInput>
            <AcceptText>I don’t mind going with another Local Expert.</AcceptText>
          </AcceptSwapContainer>
        </ReplaceableContainer>,
        <HR key="hr" />
      ]}
    </Fragment>
  );
};

SwapBlock.propTypes = {
  availability: PropTypes.object,
  trip: PropTypes.object,
  toggleAcceptSwap: PropTypes.func,
  sessionData: PropTypes.object,
};

export default withTrip(enhance(SwapBlock));
